module.exports = __webpack_public_path__ + "static/caisse-side-8053bc30d2d9cfff2cb510d9d6c837ac.png";